import {Icon20Users3} from "@vkontakte/icons";
import {useRouteNavigator} from "@vkontakte/vk-mini-apps-router";
import {Avatar, Button, Card, Cell, Header, Separator, Spacing, Spinner} from "@vkontakte/vkui";
import React, {useEffect, useState} from 'react';
import {getWeeklyPlayerRating} from "../../services/player";

// Rating - блок для отображения рейтинга игроков
export function Rating() {
    const routeNavigator = useRouteNavigator();
    const [players, setPlayers] = useState([]);
    const [currentPlayerRank, setCurrentPlayerRank] = useState(0);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        getWeeklyPlayerRating().then(resp => {
            const data = resp.data.response;
            if (data === null) {
                return;
            }

            setCurrentPlayerRank(data.player_rank);

                if (data?.winners?.length !== 0) {
                    const players = data.winners.slice(0, 3).map(player => {
                        const points = player?.weekly_score || 0;
                        const games = player?.weekly_games || 0;
                        return (<Cell before={<Avatar src={player.avatar}/>}
                                      key={player.id}
                                      subtitle={`Очков: ${points} | Игр: ${games}`}
                                      disabled={true}
                                      className={"vkui-cell-text"}
                        >
                            <span className={"text-gray-800"}>{player.name}</span>
                        </Cell>)
                    })
                    setPlayers(players);
                }
        }).catch(err => {
            console.log("getWeeklyPlayerRating", err);
        }).finally(() => {
            setIsLoading(false);
        })
    }, []);

    const clickHandler = () => {
        // Переходим на страницу с рейтингом
        routeNavigator.push('/rating');
    }

    return (<div className={"flex w-full flex-col"}>
        <div className="arcade-panel w-full">
            <Header subtitle={currentPlayerRank > 0 ? `Вы на ${currentPlayerRank} месте 🔥` : "Недельный зачёт"}>
                <div className={"flex items-center gap-2"}>
                    <span className={"arcade-title text-gray-800"}>Лучшие игроки</span>
                    {isLoading && <Spinner size={"small"}/>}
                </div>
            </Header>

            {/* Плейсхолдеры сохраняют высоту блока и убирают мерцание во время загрузки */}
            {isLoading && (
                <div className={"px-4 pb-4"}>
                    <div className={"animate-pulse flex flex-col gap-3"}>
                        <div className={"h-10 rounded-ui bg-ui-muted/70"}></div>
                        <div className={"h-10 rounded-ui bg-ui-muted/60"}></div>
                        <div className={"h-10 rounded-ui bg-ui-muted/50"}></div>
                    </div>
                </div>
            )}

            {!isLoading && <>
                {players.length <= 0 && (
                    <div className={"flex w-full items-center justify-center mb-3"}>
                        <p className={"text-xs text-gray-700"}>Рейтинг пока пуст</p>
                    </div>
                )}

                {players.length > 0 && <>
                    {players}
                    <Spacing size={24}>
                        <Separator/>
                    </Spacing>
                    <Button
                        onClick={clickHandler}
                        before={<Icon20Users3/>}
                        appearance={"neutral"}
                        size={"s"}
                        align={"center"}
                        stretched={true}
                        mode={"link"}
                        className={"text-gray-800"}
                    >
                        Весь рейтинг
                    </Button>
                    <Spacing size={12}/>
                </>}
            </>}
        </div>
    </div>);
}
